export const DefaultAddressMapper = (storeAddress) => {
  return {
    line1: storeAddress?.AddressFields?.line1 || '',
    line2: storeAddress?.AddressFields?.line2 || '',
    line3: storeAddress?.AddressFields?.line3 || '',
    postalCode: storeAddress?.AddressFields?.postalCode || '',
  };
};
